import { CF2Component } from 'javascript/lander/runtime'
import { debounce } from '../../Utils/general'
import Fetcher, { MANUALLY_ABORTED } from 'javascript/lander/utils/fetcher'

const allProductsById = {}
let productSearchFetcher: Fetcher<any> | null

const fetchProducts = (component: CF2Component, searchQuery: string) => {
  if (productSearchFetcher) {
    productSearchFetcher.abort()
  }

  const url = new URL('/products/search', window.location.origin)
  url.searchParams.set('q', searchQuery)

  productSearchFetcher = new Fetcher()

  return productSearchFetcher
    .fetch(
      url.toString(),
      {
        headers: { 'Content-Type': 'application/json' },
      },
      { retries: 3, shouldCaptureServerError: true }
    )
    .then((res) => {
      if (res instanceof Response && res.ok) {
        return res.json()
      }
      throw new Error('Search request failed')
    })
    .then((json) => {
      const products = json.products
      if (!products) return

      handleSearchResults(component, products, searchQuery)
    })
    .catch((error) => {
      if (error === MANUALLY_ABORTED) {
        return
      }
      console.error('Product search error:', error)
    })
    .finally(() => {
      productSearchFetcher = null
      hideLoading(component)
    })
}

const handleSearchResults = (component: CF2Component, products: any[], searchQuery: string) => {
  hideLoading(component)

  if (products.length > 0) {
    updateProducts(component, products)
    hideTitle(component)
    showSearchProducts(component)
    hideResultsNotFound(component)
  } else {
    hideProducts(component)
    hideTitle(component)
    showResultsNotFound(component, searchQuery)
  }
}

const searchProducts = (search: string, component: CF2Component) => {
  showLoading(component)
  fetchProducts(component, search)
}

const debounceHandler = debounce(
  ([evt, component]) => searchProducts((evt.target as HTMLInputElement).value, component),
  500
)

export const mountComponent = (component: CF2Component): void => {
  showTitle(component)
  productsReady(component)
  const searchIcon = component.element.querySelector('[href="#open-store-search"]')
  searchIcon.addEventListener('click', () => showModal(component))

  const searchElement = component.element.querySelector('[name="store-search"]')
  searchElement.addEventListener('input', (evt) => debounceHandler(evt, component))
  searchElement.addEventListener('focus', (evt) => debounceHandler(evt, component))

  const modal = component.getComponent('Modal/V1')
  modal.element.addEventListener('click', () => {
    hideModal(component)
  })

  component.element.querySelector('.elStoreSearch').addEventListener('click', (evt) => {
    evt.stopPropagation()
  })

  component.element.querySelectorAll('.elModalClose').forEach((elem) =>
    elem.addEventListener('click', () => {
      hideModal(component)
    })
  )

  document.addEventListener('keydown', (evt) => {
    if (evt.key === 'Escape') hideModal(component)
  })
}

const getProductsElementComponent = (component: CF2Component) => {
  return component.getComponent('StoreSearchProducts')
}

const updateProducts = (component: CF2Component, products) => {
  ;(getProductsElementComponent(component) as any).selected_products = products
  getProductsElementComponent(component).render()
}

const showModal = (component: CF2Component) => {
  document.documentElement.classList.add('hide-page-scroll')
  component.getComponent('Modal/V1').element.style.display = 'flex'
  component.element.querySelector('.elStoreSearch').setAttribute('data-animation-state', 'running')
  ;(component.element.querySelector('[name="store-search"]') as HTMLInputElement).focus()
}

const productsReady = (component: CF2Component) => {
  updateProducts(component, Object.values(allProductsById).slice(0, 6))
  getProductsElementComponent(component).element.classList.remove('forceHide')
  component.element.querySelector('.elStoreSearchTitle').classList.remove('forceHide')
  ;(component.element.querySelector('[name="store-search"]') as HTMLInputElement).disabled = false
  component.element.querySelector('.elStoreSearchLoading').classList.add('forceHide')
}

const hideModal = (component: CF2Component) => {
  document.documentElement.classList.remove('hide-page-scroll')
  component.getComponent('Modal/V1').element.style.display = 'none'
}

const showSearchProducts = (component: CF2Component) => {
  getProductsElementComponent(component).element.classList.remove('forceHide')
}

const hideProducts = (component: CF2Component) => {
  getProductsElementComponent(component).element.classList.add('forceHide')
}

const hideTitle = (component: CF2Component) => {
  component.element.querySelector('.elStoreSearchTitle').classList.add('forceHide')
}

const showTitle = (component: CF2Component) => {
  component.element.querySelector('.elStoreSearchTitle').classList.remove('forceHide')
}

const showResultsNotFound = (component: CF2Component, text: string) => {
  const [split1, split2] = (component as any).not_found_text.split('{search}')
  component.element.querySelector('.elStoreSearchResultsNotFound').innerHTML = split1 + text + split2
  component.element.querySelector('.elStoreSearchResultsNotFound').classList.remove('forceHide')
}

const hideResultsNotFound = (component: CF2Component) => {
  component.element.querySelector('.elStoreSearchResultsNotFound').classList.add('forceHide')
}

const showLoading = (component: CF2Component) => {
  component.element.querySelector('.elStoreSearchLoading').classList.remove('forceHide')
}

const hideLoading = (component: CF2Component) => {
  component.element.querySelector('.elStoreSearchLoading').classList.add('forceHide')
}
